import { Modal, DatePickerField } from 'components';
import Button from 'components/Button';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import SelectField from 'components/Forms/SelectField';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { yup } from 'libs';
import { FC, useState } from 'react';
import { arrowLeft } from 'assets';

import SectionStyled, { HeaderStyle } from './styles';

interface Props {}

const ModalOutputRKY: FC<Props> = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const formik = useFormik({
    initialValues,
    validationSchema,
    async onSubmit(values) {
      console.log(values);
      setVisible(false);
    },
  });

  return (
    <>
      <button onClick={() => setVisible(true)}>Open modal ModalOutputRKY</button>
      <Modal title={<Header />} visible={visible} footer={false} width={560}>
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="group-input">
                <div className="box-select">
                  <Form.Item className="input-onsite" label="現場" colon={false} name="sitename">
                    <div className="titleSiteName">{titleSiteName}</div>
                  </Form.Item>
                </div>
                <div className="box-select">
                  <Form.Item className="input-onsite" label="業者" colon={false} name="trader">
                    <SelectField data={trader} name="trader" className="select-field" />
                  </Form.Item>
                </div>
                <div className="box-select">
                  <Form.Item
                    className="input-onsite"
                    label="出力期間"
                    colon={false}
                    name="startDate"
                  >
                    <DatePickerField
                      name="startDate"
                      className="select-date"
                      placeholder="開始日を選択"
                    />
                  </Form.Item>
                  <div className="center-text">〜</div>
                  <Form.Item className="input-checkbox" label={<span />} name="endDate">
                    <DatePickerField
                      name="endDate"
                      className="select-date"
                      placeholder="終了日を選択"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="ant-modal-footer">
                <Button className="button-secondary" onClick={() => setVisible(false)}>
                  キャンセル
                </Button>
                <ButtonSubmit>出力</ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
    </>
  );
};

export default ModalOutputRKY;

const trader = [
  { label: '全て', value: '全て' },
  { label: 'name 1', value: 1 },
  { label: 'name 2', value: 2 },
  { label: 'name 3', value: 3 },
];

const titleSiteName = '東京内田中様集合住宅新築工事';

const initialValues = {
  trader: '全て',
  startDate: '',
  endDate: '',
};

const validationSchema = yup.object().shape({
  trader: yup.string().required(),
  startDate: yup.date().nullable().required(),
  endDate: yup.date().nullable().required(),
});

const Header: FC = () => {
  return (
    <HeaderStyle>
      <img src={arrowLeft} alt="" />
      <div>RKYの出力</div>
    </HeaderStyle>
  );
};
